import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTrophy, FaUsers, FaCalendarCheck, FaMedal, FaArrowRight } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const IntermediateCoaching1 = () => {

    return (
        <>
            <Helmet>
                <title>Intermediate Coaching</title>
            </Helmet>
            <div className="about-page">
                <div className="page-header">
                    <div className="container">
                        <h1>Intermediate Coaching</h1>
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <span>Intermediate Coaching</span>
                        </div>
                    </div>
                </div>

                <section className="about-intro section">
                    <div className="container">
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <span className="section-subtitle">Imperial Badminton Academy</span>
                                <h2>Intermediate Coaching Program</h2>
                                <p>
                                    The Intermediate Coaching Program at Imperial Badminton Academy is designed for players who have mastered basic badminton skills and are ready to elevate their performance. This program focuses on refining techniques, improving footwork efficiency, enhancing fitness levels, and developing match awareness to prepare players for competitive play.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="intro-img-main">
                                    <img src="/img/Intermediate Coaching.jpg" alt="Academy Training" />
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Who Should Join the Intermediate Program?</h3>
                                <p>
                                    Players with basic knowledge of strokes and rules
                                    <br></br>
                                    Beginners who have completed foundational training
                                    <br></br>
                                    School or club-level players
                                    <br></br>
                                    Players aiming to transition toward competitive badminton
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Training Philosophy</h3>
                                    <p>Intermediate coaching bridges the gap between basic learning and advanced competition. Our training approach emphasizes consistency, accuracy, and tactical understanding. Players are encouraged to develop disciplined practice habits while improving speed, endurance, and decision-making on the court.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Core Areas of Intermediate Training</h3>
                                <p>
                                    Smash technique and placement
                                    <br></br>
                                    Drop shots and deceptive strokes
                                    <br></br>
                                    Drive shots and net control
                                    <br></br>
                                    Backhand improvement
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Footwork & Speed Development</h3>
                                    <p>Multi-directional movement drills
                                        <br></br>
                                        Speed and agility exercises
                                        <br></br>
                                        Balance and recovery techniques
                                        <br></br>
                                        Court coverage improvement</p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Tactical & Match Awareness</h3>
                                <p>
                                    Shot selection and rally building
                                    <br></br>
                                    Opponent analysis
                                    <br></br>
                                    Court positioning
                                    <br></br>
                                    Singles and doubles strategies
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Fitness & Coordination</h3>
                                    <p>Endurance and stamina
                                        <br></br>
                                        Core strength
                                        <br></br>
                                        Flexibility and injury prevention
                                        <br></br>
                                        Explosive power</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Match Practice Sessions</h3>
                                    <p>Practice matches
                                        <br></br>
                                        Situational drills
                                        <br></br>
                                        Score-based games</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Mental Strength & Discipline</h3>
                                    <p>Maintain focus under pressure
                                        <br></br>
                                        Build confidence
                                        <br></br>
                                        Develop competitive mindset
                                        <br></br>
                                        Handle match situations calmly
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Performance Monitoring & Feedback</h3>
                                    <p>Coaches regularly assess player progress and provide constructive feedback. Individual strengths and areas for improvement are identified, ensuring consistent development and readiness for advanced training.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Benefits of Intermediate Coaching at Imperial Badminton Academy</h3>
                                    <p>Improved technical accuracy
                                        <br></br>
                                        Enhanced speed and endurance
                                        <br></br>
                                        Better match understanding
                                        <br></br>
                                        Increased confidence and consistency
                                        <br></br>
                                        Strong foundation for advanced competitive training
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Progression Path</h3>
                                    <p>Upon achieving the required skill level and performance consistency, players are guided toward the Advanced & Competitive Coaching Program.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Take the Next Step in Your Badminton Journey</h3>
                                    <p>The Intermediate Coaching Program at Imperial Badminton Academy is ideal for players ready to push their limits and refine their skills. With expert coaching, structured training, and a supportive environment, players gain the confidence and capability to perform at higher levels.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default IntermediateCoaching1;
